import { render, staticRenderFns } from "./CompanyInfoUserModal.vue?vue&type=template&id=1d482dce&"
import script from "./CompanyInfoUserModal.vue?vue&type=script&lang=ts&"
export * from "./CompanyInfoUserModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d482dce')) {
      api.createRecord('1d482dce', component.options)
    } else {
      api.reload('1d482dce', component.options)
    }
    module.hot.accept("./CompanyInfoUserModal.vue?vue&type=template&id=1d482dce&", function () {
      api.rerender('1d482dce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyInfoUserModal.vue"
export default component.exports